import axios from "../../../axios"

export default {
  publishedNews() {
    return axios.post('', {
      query: `
        query {
          publishedNews {
            month_year,
            quantity
          }
        }
      `
    })
  },
  newsletterSubscriptions() {
    return axios.post('', {
      query: `
        query {
          newsletterSubscriptions {
            month_year,
            quantity
          }
        }
      `
    })
  }
}